@if (store.loadingFor('getAnamneses')()) {
    <app-loading></app-loading>
} @else if (store.anamnesis(); as anamnesis) {
    <div class="anamnesis-widget">
        <div class="anamnesis-layout">
            <div class="anamnesis-summary">
                <div class="flex-column gap-x-small">
                    <span class="font-semibold">{{ 'anamnesis.widget.fields.dateFrom' | translate }}</span>
                    <span>{{ anamnesis.dateFrom | shortDate }}</span>
                </div>

                <div class="flex-column gap-x-small">
                    <span class="font-semibold">{{ 'anamnesis.widget.fields.dateTo' | translate }}</span>
                    <span>{{ (anamnesis.dateTo | shortDate) || '—' }}</span>
                </div>

                <div class="flex-column gap-x-small">
                    <span class="font-semibold">{{ 'anamnesis.widget.fields.doctor' | translate }}</span>
                    @if (anamnesis.doctor; as doctor) {
                        <app-doctor-chip
                            [doctor]="doctor"
                            [renderDetails]="false"
                        ></app-doctor-chip>
                    } @else {
                        <span>—</span>
                    }
                </div>

                <div class="anamnesis-diagnoses flex-column gap-x-small">
                    <span class="font-semibold">{{ 'anamnesis.widget.fields.diagnosticSummary' | translate }}</span>
                    @if (diagnoses().length) {
                        <div class="flex flex-wrap gap-small">
                            @for (diagnosis of diagnoses(); track diagnosis.code; let isPrimary = $first) {
                                <p-tag
                                    [value]="diagnosis.code"
                                    [severity]="isPrimary ? undefined : 'secondary'"
                                    [pTooltip]="diagnosis.name"
                                ></p-tag>
                            }
                        </div>
                    } @else {
                        <span>—</span>
                    }
                </div>
            </div>

            <div class="anamnesis-sections">
                @if (visibleFields().anamnesis) {
                    <section class="anamnesis-section flex-column gap-small">
                        <h3>{{ 'anamnesis.widget.fields.anamnesis' | translate }}</h3>
                        @if (anamnesis.anamnesis) {
                            <div class="rich-text" [innerHTML]="anamnesis.anamnesis"></div>
                        } @else {
                            <span>—</span>
                        }
                    </section>
                }

                @if (visibleFields().socialAnamnesis) {
                    <section class="anamnesis-section flex-column gap-small">
                        <h3>{{ 'anamnesis.widget.fields.socialAnamnesis' | translate }}</h3>
                        @if (anamnesis.socialAnamnesis) {
                            <div class="rich-text" [innerHTML]="anamnesis.socialAnamnesis"></div>
                        } @else {
                            <span>—</span>
                        }
                    </section>
                }

                @if (visibleFields().nurseRecommendations) {
                    <section class="anamnesis-section flex-column gap-small">
                        <h3>{{ 'anamnesis.widget.fields.nurseRecommendations' | translate }}</h3>
                        @if (anamnesis.nurseRecommendations) {
                            <div class="rich-text" [innerHTML]="anamnesis.nurseRecommendations"></div>
                        } @else {
                            <span>—</span>
                        }
                    </section>
                }

                @if (visibleFields().statusPraesens) {
                    <section class="anamnesis-section flex-column gap-small">
                        <h3>{{ 'anamnesis.widget.fields.statusPraesens' | translate }}</h3>
                        @if (anamnesis.statusPraesens) {
                            <div class="rich-text" [innerHTML]="anamnesis.statusPraesens"></div>
                        } @else {
                            <span>—</span>
                        }
                    </section>
                }
            </div>
        </div>
    </div>
} @else {
    <app-empty-state></app-empty-state>
}
